import { render, staticRenderFns } from "./YoungList.vue?vue&type=template&id=9f702d98&scoped=true&"
import script from "./YoungList.vue?vue&type=script&lang=js&"
export * from "./YoungList.vue?vue&type=script&lang=js&"
import style0 from "./YoungList.vue?vue&type=style&index=0&id=9f702d98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f702d98",
  null
  
)

export default component.exports